// src/components/SidebarCard.js

import React from 'react';
import { Card,Grid,Avatar, CardContent, Typography, List, ListItem, ListItemText } from '@mui/material';

export default function LeftSidebarCard() {
    return (
        <Card sx={{ marginBottom: '20px' }}>
            <Card sx={{ marginBottom: 2 }}>
                <CardContent>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item>
                            <Avatar src="https://via.placeholder.com/60" sx={{ width: 60, height: 60 }} />
                        </Grid>
                        <Grid item>
                            <Typography variant="h6">张三</Typography>
                            <Typography variant="body2" color="text.secondary">
                                Company
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                                东京 前端开发工程师
                            </Typography>
                        </Grid>
                    </Grid>
                    {/* <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
                        个人简介摘要内容，可以简短描述一下自己...
                    </Typography> */}
                </CardContent>
            </Card>
            <CardContent>
                {/* <Typography variant="h6" gutterBottom>
                    我的面板
                </Typography> */}
                <List>
                    <ListItem button>
                        <ListItemText primary="我的职位" />
                    </ListItem>
                    <ListItem button>
                        <ListItemText primary="发布免费职位" />
                    </ListItem>
                    <ListItem button>
                        <ListItemText primary="管理职位发布" />
                    </ListItem>
                </List>
            </CardContent>
        </Card>
    );
}